import { internalAssetToRpcAsset, type ChainflipAsset } from '@chainflip/utils/chainflip';
import { useQuery } from '@tanstack/react-query';
import BigNumber from 'bignumber.js';
import { chainflipAssetMap } from '@/shared/utils/env';
import makeRpcRequest from '@/shared/utils/rpc';

const sqrtPriceX96ToPrice = (amount: string) =>
  BigNumber(amount)
    .div(2 ** 96)
    .pow(2);

export default function usePoolPrice(baseAsset: ChainflipAsset) {
  const { data, isLoading } = useQuery({
    queryKey: ['pool_price_v2', baseAsset],
    queryFn: () =>
      makeRpcRequest(
        'cf_pool_price_v2',
        internalAssetToRpcAsset[baseAsset],
        internalAssetToRpcAsset.Usdc,
      ),
    refetchInterval: 10_000,
  });

  const buyPrice = data?.buy != null ? sqrtPriceX96ToPrice(data.buy.toString()) : null;
  const sellPrice = data?.sell != null ? sqrtPriceX96ToPrice(data.sell.toString()) : null;
  const rangeOrderPrice =
    data?.range_order != null ? sqrtPriceX96ToPrice(data.range_order.toString()) : null;

  const rateDecimals = chainflipAssetMap.Usdc.decimals - chainflipAssetMap[baseAsset].decimals;

  return {
    isLoading,
    buyPrice: buyPrice?.shiftedBy(-rateDecimals).toNumber(),
    sellPrice: sellPrice?.shiftedBy(-rateDecimals).toNumber(),
    rangeOrderPrice: rangeOrderPrice?.shiftedBy(-rateDecimals).toNumber(),
  };
}
